let cachedLimits: Record<number, number> | null = null

export function setMt5StdNetworkLimits(limits: Record<number, number>): void {
  cachedLimits = limits
}

export function getMt5StdNetworkLimitsCache(): Record<number, number> | null {
  return cachedLimits
}
